import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import TechnicianForm from './TechnicianForm';
import AdminPage from './AdminPage';
import AdminRoute from "./AdminRoute";
import ErrorBoundary from "./ErrorBoundary";
import AuthCallback from "./AuthCallback";
import MsalTestApp from "./MsalTestApp";
import ToDoList from './ToDoList';

// Add global MSAL event logging
// msalInstance.addEventCallback((event) => {
//   if (event.eventType === "msal:loginFailure" || event.error) {
//     console.error("[MSAL ERROR]", event.error);
//   }
// });

function AuthenticatedApp() {
  const { inProgress, accounts } = useMsal();
  console.log("[MSAL] AuthenticatedApp render. inProgress:", inProgress, "accounts:", accounts);
  if (inProgress === InteractionStatus.Startup || inProgress === InteractionStatus.HandleRedirect) {
    console.log("[MSAL] Waiting for MSAL to finish initializing...");
    return <div>Loading authentication...</div>;
  }
  return (
    <Routes>
      <Route path="/" element={<TechnicianForm showAllCustomers={localStorage.getItem('showAllCustomers') === 'true'} />} />
      <Route path="/admin" element={
        <AdminRoute>
          <AdminPage />
        </AdminRoute>
      } />
      <Route path="/auth-callback" element={<AuthCallback />} />
      <Route path="/msal-test" element={<MsalTestApp />} />
      <Route path="/todo" element={<ToDoList />} />
    </Routes>
  );
}

function App() {
  console.log("[MSAL] App render");
  return (
    <ErrorBoundary>
      <Router>
        <AuthenticatedApp />
      </Router>
    </ErrorBoundary>
  );
}

export default App;
